module.exports = __webpack_public_path__ + "static/media/12_thehangedman.6e629bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12_thehangedman.png
// module id = 75
// module chunks = 0